var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"site-wrapper"}},[_c('header',{staticClass:"site-header",class:{
                'is--extended': _vm.isHeaderExtended,
                'is--active': _vm.isHeaderActive
            },attrs:{"role":"banner"}},[_vm._t("header")],2),_c('main',{staticClass:"main-container flex-grow-1",attrs:{"role":"main"}},[_c('div',{staticClass:"main-container-wrapper"},[_vm._t("main")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }